import loadGoogleMapsApi from 'load-google-maps-api'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

const branchLocator = document.querySelector('[data-branch-locator]')

/**
 * Set up handling for clicks on branch cards
 * @param map
 */
const bindLocations = (map) => {
    const branchLocations = branchLocator.querySelectorAll('[data-location]')

    Array.from(branchLocations).forEach((location) => {
        const cardLink = location.querySelector('[data-link]')

        location.addEventListener('click', function () {
            handleLocationClick(this, map, branchLocations)
        })

        cardLink.addEventListener('click', (event) => event.stopPropagation())
    })
}

/**
 * Handle zooming map on branch card clicks
 * @param targetLocation
 * @param map
 * @param allLocations
 */
const handleLocationClick = (targetLocation, map, allLocations) => {
    const lat = targetLocation.getAttribute('data-lat')
    const lng = targetLocation.getAttribute('data-lng')
    Array.from(allLocations).forEach(location => location.removeAttribute('data-active'))
    targetLocation.setAttribute('data-active', 'true')
    map.panTo({
        lat: parseFloat(lat),
        lng: parseFloat(lng),
    })
    map.setZoom(16)
}

/**
 * Add a location marker to the map
 * @param elMarker
 * @param map
 * @param mapsService
 */
const setMarker = (elMarker, map, mapsService) => {
    const lat = elMarker.getAttribute('data-lat')
    const lng = elMarker.getAttribute('data-lng')

    const marker = new mapsService.Marker({ //eslint-disable-line
        position: {
            lat: Number(lat),
            lng: Number(lng),
        },
        icon: {
            url: '/media/metro-location-tag.png',
            size: new mapsService.Size(30, 45),
            scaledSize: new mapsService.Size(30, 45),
        },
        optimized: false,
        map: map,
    })

    // Add marker to be used for map bound fitting
    map.markers = [...map.markers, marker]

    // Create an info window if the marker has content
    if (elMarker.innerHTML) {
        const infoWindow = new mapsService.InfoWindow({
            content: elMarker.innerHTML,
        })

        mapsService.event.addListener(marker, 'click', () => infoWindow.open(map, marker))
    }
}

/**
 * @param mapsService
 * @param el
 * @param options
 */
const initMap = (mapsService, el, options) => {
    const markers = el.querySelectorAll('[data-marker]')
    const map = new mapsService.Map(el, options)
    const mapBounds = new mapsService.LatLngBounds()
    map.markers = []

    // Create a marker from each location
    Array.from(markers).forEach((marker) => {
        setMarker(marker, map, mapsService)
    })

    // Expand map bounds to fit all marker
    map.markers.forEach((marker) => {
        mapBounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
        })
    })

    // Fit all markers within the map's bounds
    map.fitBounds(mapBounds)

    return map
}

if (branchLocator) {
    const elMap = document.getElementById('branchMap')
    const mapArgs = {
        zoom: 13,
        center: { lat: 43.23401067, lng: -70.8247552 },
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
    }
    loadGoogleMapsApi({
        key: 'AIzaSyAdYQ1sI6J36hbsoLbawY7d_A3gILQOIyE',
    }).then((googleMaps) => {
        const map = initMap(googleMaps, elMap, mapArgs)

        // Set up for clicks on locations cards
        bindLocations(map, googleMaps)
    }).catch((error) => {
        console.error(error)
    })

    ScrollTrigger.matchMedia({
        '(min-width: 850px)': () => {
            ScrollTrigger.create({
                trigger: branchLocator,
                start: 'top top+=76px',
                end: 'bottom bottom',
                pin: elMap,
                pinSpacing: false,
            })
        },
    })
}
